import { Box, Group, Stack }   from "@mantine/core";
import { useRouter }           from "next/router";
import { useEffect, useState } from "react";

import { PrimaryButton } from "_components/atoms/button";
import Image             from "_components/atoms/image";
import Typography        from "_components/atoms/typography";
import { shortenNumber } from "_components/features/player/utils";
import FollowUser        from "_components/molecules/followUser";

import useStyles from "./styles";

function InfoOverlay ( {
	reel,
	isOwnProfile,
	handleGAEvent,
	inView
} ) {

	const { classes }    = useStyles ( );
	const maxTitleLength = 50;
	const router         = useRouter ();
	const title          = reel.title;

	const [ showMore, setShowMore ] = useState ( title.length < maxTitleLength );

	const stopPropagation = e => {
		e.stopPropagation ();
	};

	useEffect ( () => {
		if ( !inView && title.length > maxTitleLength ) {
			setShowMore ( false );
		}
	}, [ inView ] );

	return (
		<>
			<Box
				className    = { classes.infoRoot }
				onMouseDown  = { stopPropagation }
				onMouseUp    = { stopPropagation }
				onTouchEnd   = { stopPropagation }
				onTouchStart = { stopPropagation }
			>
				<Group>
					<Image
						className = { classes.actorImage }
						onClick   = { () => router.push ( `/profile/${ reel.actorDetails.id }` ) }
						src       = { reel.actorDetails.photo }
					/>

					<Stack justify = { "center" }
						spacing       = { 0 }
					>
						<Group>
							<Typography
								className = { classes.actorName }
								onClick   = { () => router.push ( `/profile/${ reel.actorDetails.id }` ) }
								title     = { reel.actorDetails.name }
							/>

							<FollowBtn
								from          = { "reels" }
								handleGAEvent = { handleGAEvent }
								isFollowing   = { !!reel.actorDetails.isFollowing }
								isOwnProfile  = { isOwnProfile }
								userId        = { reel.actorDetails.id }
								userName      = { reel.actorDetails.name }
							/>
						</Group>

						<Typography
							className = { classes.reelViews }
							title     = { `${ shortenNumber ( reel?.views ) } Views` }
						/>
					</Stack>
				</Group>

				<div className = { classes.descWrapper }
					onClick       = { e => {
						e.stopPropagation ();
						setShowMore ( o => !o );
					} }
				>

					<Typography
						className   = { classes.reelTitle }
						data-opened = { showMore ? showMore : undefined }
						size        = { "sm" }
						title       = { title }
					/>
				</div>
			</Box>

			<div className = { classes.test }></div>
		</>
	);
}

function FollowBtn ( props ) {
	const {
		isOwnProfile,
		from,
		userId,
		userName,
		isFollowing,
		handleGAEvent
	} = props;
	const { classes } = useStyles ();

	const [ following, setFollowing ] = useState ( isFollowing );

	if ( from === "profile-header" && isOwnProfile )
		return null;

	return (
		<div
			className = { classes.menuItem }
		>
			<FollowUser
				feedTop           = { false }
				followComponent   = { (
					<PrimaryButton
						className = { classes.followComponent }
						onClick   = { () => {
							handleGAEvent ( "follow" );
						} }
						title     = { (
							<Typography
								className = { classes.iconText }
								size      = { "xs" }
								title     = { "+ Follow" }
							/>
						) }
					/>
				) }
				fromFeedElements  = { false }
				fromHomePage      = { false }
				isFollowing       = { isFollowing }
				unfollowComponent = { (
					<PrimaryButton
						className = { classes.followComponent }
						onClick   = { () => {
							handleGAEvent ( "unfollow" );
						} }
						title     = { (
							<Typography
								className = { classes.iconText }
								size      = { "xs" }
								title     = { "Following" }
							/>
						) }
					/>
				) }
				userId            = { userId }
				userName          = { userName }
			/>
		</div>

	);
}
export default InfoOverlay;
